import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-fa-qt3-text',
  templateUrl: './qt3-text.component.html',
  styleUrls: ['./qt3-text.component.css'],
})
export class Qt3TextComponent implements OnInit {
  @Input() QuestionNo: number;
  @Input() Question: string;
  @Input() answer?: any;
  @Input() template?: any;
  @Output() selectedtemplate: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  q: string = '';
  ngOnInit() {
    // if(this.Question=='default'){
    //   this.Question=' In the following figure, what is the area of the shaded circle inside of the square?';
    //   this.answer=[{answer:'Answer 1'},{answer:'Answer 2'},{answer:'Answer 3'},{answer:'Answer 4'}];
    //       }

    if (this.Question == 'default' || this.Question == 'default1') {
      this.q = this.Question;
      console.log(this.Question, this.q);
      //this.QuestionNo=1;
      this.Question =
        'In the following figure, what is the area of the shaded circle inside of the square?';
      this.answer = [
        { answer: 'Answer 1' },
        { answer: 'Answer 2' },
        { answer: 'Answer 3' },
        { answer: 'Answer 4' },
      ];
    }
  }

  selecttemplate() {
    this.selectedtemplate.emit(this.template);
  }
}
